import { Component, ElementRef, EventEmitter, Input, OnInit, OnChanges, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Story } from 'src/app/model/story.model';
import { Storybook } from 'src/app/model/storybook.model';
import { Student } from 'src/app/model/student.model';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EventEmitterService } from '../../services/event.emitter.service';

@Component({
  selector: 'app-book-list',
  templateUrl: './book-list.component.html',
  styleUrls: ['./book-list.component.scss'],
})
export class BookListComponent implements OnInit, OnChanges {

  strname: any;

  storybookLevelRefObj = [
    'aa', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'Z1', 'Z2'
  ];
  displayLevel: string = "aa";
  storybookCategory: string = "All";
  language: string;
  textDir: string;
  private destroy$ = new Subject<void>();

  @Input() books: { storyName: string; hasAudio: boolean }[] = [];
  @Input() storybooks: string;
  @Input() isAssignmentMode: string;
  storybookObjects: Storybook[] = [];
  currentDisplayStorybookObjects: Storybook[] = [];
  playableStorybookLevels: string[] = [];
  @Output() bookOpened = new EventEmitter();

  constructor(
      private router: Router,
      private translate: TranslateService,
      private eventEmitterService: EventEmitterService
    ) {
    this.language = translate.currentLang;
    translate.onLangChange.pipe(takeUntil(this.destroy$))
        .subscribe(({ lang }) => {
          this.language = lang
          if (this.language === 'ar'){
            this.textDir = 'rtl';
          }
          else {
            this.textDir = 'ltr';
          }
        });
    this.eventEmitterService.storybookCategoryEvent
      .subscribe((data:any) => {
        //console.log('Event message from Component Book list: ' + data);
        this.setStorybookCategory(data);
    });
  }
  
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {

    // check before
    if (this.storybooks == null || this.storybooks.length == 0)
      return;

    //
    this.storybookObjects = JSON.parse(this.storybooks);
    this.calculatePlayableStorybookLevels();
    this.filterStorybooks();
  }

  ngOnChanges() {

    // YA210928 we add this so when storybooks is not empty anymore, the list of books does show

    // check before
    if (this.storybooks == null || this.storybooks.length == 0)
      return;

    //
    this.storybookObjects = JSON.parse(this.storybooks);
    this.calculatePlayableStorybookLevels();
    this.filterStorybooks();
  }

  emitBookName(book: { storyName: string; hasAudio: boolean }) {
    this.bookOpened.emit(book);
  }

  f1(strname) {
    this.strname = strname;
    localStorage.setItem("strname", JSON.stringify(this.strname));
  }

  filterStorybooks(): void {

    this.currentDisplayStorybookObjects = [];

    //
    for (var i = 0; i < this.storybookObjects.length; i++) {

      var currentStorybookLevel = this.storybookObjects[i].storybookReadingLevel;
      var currentStorybookCategory = this.storybookObjects[i].storybookCategory;

      if (this.storybookCategory != "All"){
        if (currentStorybookLevel == this.displayLevel && currentStorybookCategory == this.storybookCategory) {
          if (this.playableStorybookLevels.includes(currentStorybookLevel)) {
            this.storybookObjects[i].playable = true;
          }
          this.currentDisplayStorybookObjects.push(this.storybookObjects[i]);
        }
      }else {
        if (currentStorybookLevel == this.displayLevel) {
          if (this.playableStorybookLevels.includes(currentStorybookLevel)) {
            this.storybookObjects[i].playable = true;
          }
          this.currentDisplayStorybookObjects.push(this.storybookObjects[i]);
        }
      }
      
    }
  }

  calculatePlayableStorybookLevels() {
    var user: Student = JSON.parse(localStorage.getItem("user"));
    if (user) {
      var studentReadingLevel = user.studentReadingLevel
      for (var i = 0; i < this.storybookLevelRefObj.length; i++) {
        var currentStorybookLevel = this.storybookLevelRefObj[i];
        if (currentStorybookLevel == studentReadingLevel) {
          this.playableStorybookLevels.push(currentStorybookLevel);
          break;
        }
        this.playableStorybookLevels.push(currentStorybookLevel);
      }
    }
  }

  changeStorybookLevel(levelButton) {
    this.displayLevel = levelButton.target.attributes['storybookLevel'].value;
    this.filterStorybooks();
  }

  setStorybookCategory(storybookCategory: any){
    this.storybookCategory = storybookCategory;
    this.filterStorybooks();
  }

  showQuiz(storyBook: Storybook) {
    this.f1(storyBook.storyName);
    localStorage.setItem("storybook", JSON.stringify(storyBook));
    this.router.navigate([`/story/${storyBook.quizId}/quiz`])
  }

  showStory(storyBook: Storybook) {
    localStorage.setItem("storybook", JSON.stringify(storyBook));
    if (this.isAssignmentMode){
      localStorage.setItem("isAssignmentMode", this.isAssignmentMode);
    }else {
      localStorage.removeItem("isAssignmentMode");
    }
    this.router.navigate([`/story/${storyBook.storybookId}`])
  }

  storybookImageClicked(storyBook: Storybook) {
    localStorage.setItem("storybook", JSON.stringify(storyBook));
    this.router.navigate([`/story/${storyBook.storybookId}`])
  }

  storyBookLevelImgSrc(storyBook: Storybook): string {
    if(this.language === 'ar'){
      return  `../../../../assets/icons/StudentLevel/svg/studentLevel_ar_${storyBook.storybookReadingLevel.toLowerCase()}.svg`;
    } else{
      return  `../../../../assets/icons/StudentLevel/svg/studentLevel_${storyBook.storybookReadingLevel.toLowerCase()}.svg`;
    }
  }
}
